import {useDictionary} from '@adamlip/okeoke.client';
import useBasket from 'hooks/useBasket';
import {useEffect, useState, useContext} from 'react';
import {Input} from '@heroui/react';
import {AppParamsContext} from 'contexts/AppParamsContext';

export default function ServiceFee() {
	const {getValue} = useDictionary();
	const {appParams} = useContext(AppParamsContext);
	const {setNotes, notes} = useBasket();

	const [orderNotes, setOrderNotes] = useState('');

	const handleChangeNotes = (e) => setOrderNotes(e.target.value);

	const handleBlurNotes = () => setNotes(orderNotes?.slice(0, 100));

	useEffect(() => {
		if (notes) setOrderNotes(notes);
		//eslint-disable-next-line
	}, []);

	if (appParams?.basketModal?.items?.orderNotes == null || appParams?.basketModal?.items?.orderNotes === false) return null;

	return (
		<div className='my-2'>
			<Input
				aria-label='input'
				type='text'
				classNames={{
					inputWrapper: 'group-data-[focus=true]:bg-inputBackground border-1 rounded-general bg-inputBackground border-inputBorder text-inputText',
					label: appParams?.styles?.fonts?.capitalize ? 'font-bold uppercase' : '',
				}}
				name='orderNotes'
				label={getValue('app_v2_order_notes')}
				value={orderNotes}
				fullWidth={true}
				onChange={handleChangeNotes}
				onBlur={handleBlurNotes}
			/>
		</div>
	);
}
